

const __assign = (this && this.__assign) || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (const p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) { t[p] = s[p]; }
    }
  }
  return t;
};
Object.defineProperty(exports, '__esModule', { value: true });
const fetch_1 = require('../libs/fetch');
const command_1 = require('../libs/command');
const wx = require('weixin-js-sdk');

const weChat = /** @class */ (function () {
  function weChat(runtimeName) {
    this.name = runtimeName;
    console.warn('current app run on the ', runtimeName);
  }
    /**
     * 注入权限验证配置
     * @description 对于变化url的SPA的web app需在每次url变化时进行调用
     */
  weChat.prototype.config = function () {
        // 对URL编码,否则如果URL中包含&字符的时候,会错误将整个url参数解析成多个参数,
        // 破坏了url参数的完整性
    const url = encodeURIComponent(location.href);
    fetch_1.fetchJSONByGet('/api/weixin/sdk')({ url: url })
            .then(res => res.json())
            .then((res) => {
              if (!res.status) {
                /* eslint no-alert: 0 */
                console.error(res.msg);
                alert('微信信息获取异常，请退出重新登录');
                return;
              }
              wx.config(__assign({}, res.data, { debug: false,
                jsApiList: ['scanQRCode', 'getLocation', 'openLocation', 'chooseImage', 'uploadImage', 'onMenuShareTimeline',
                  'onMenuShareAppMessage', 'chooseWXPay'] }));
              wx.error((res) => {
                alert(JSON.stringify(res));
              });
            });
  };

    /**
     * 在PC环境下设置导航栏
     *
     * @param {Runtime.DwdTitleData} params
     */
  weChat.prototype.setHeader = function (params) {
    return new Promise((resolve, reject) => {
      resolve('设置导航栏成功');
    });
  };

    /**
     * 在微信环境下跳转订单详情,空函数
     *
     * @param {Runtime.DwdGoToShopOrderData} params
     */
  weChat.prototype.gotoShopOrderDetail = function (params) {
    return new Promise((resolve, reject) => {
      resolve('跳转订单详情成功');
    });
  };

    /**
     * 在微信环境下提交追加单取消原因
     *
     * @param {Runtime.DwdAppendOrderCancelReason} params
     */
  weChat.prototype.submitAppendOrderCancelReason = function (params) {
    return new Promise((resolve, reject) => {
      resolve('提交取消原因成功');
    });
  };

    /**
     * 在微信环境下关闭掉H5页面
     *
     */
  weChat.prototype.closeWindow = function () {
    wx.closeWindow();
  };
    /**
     * 在微信环境下调用打电话
     *
     * @param {Runtime.DwdCallPhone} params
     */
  weChat.prototype.callPhone = function (params) {
  };
    /**
     * 在微信环境下获取网络类型
     *
     */
  weChat.prototype.getNetworkType = function () {
    return new Promise((resolve, reject) => {
      wx.ready(() => {
        wx.getNetworkType({
          onSuccess: function (res) {
            resolve(res.networkType);
          },
          onFail: function (res) {
            reject(res);
          }
        });
      });
    });
  };
    /**
     * 在微信环境下打开外部浏览器
     *
     * @param {Runtime.DwdOpenBrowserData} params
     */
  weChat.prototype.openExternalBrowser = function (params) {
  };
    /**
     * 在微信环境下复制到剪切板
     *
     * @param {Runtime.DwdCopyToClipData} params
     */
  weChat.prototype.copyToClipBoard = function (params) {
    const text = (params || { text: '' }).text;
    return command_1.copy(text);
  };
    /**
     * 在微信环境下从剪切板获取文本
     *
     */
  weChat.prototype.pasteFromClipBoard = function () {
  };
    /**
     * 在微信环境下暂停音频
     *
     * @param {any} element
     */
  weChat.prototype.pauseAudio = function (element) {
    wx.ready(() => {
      element.pause();
            // 保证下次play的时候能够从头开始播放
      element.currentTime = 0;
    });
  };

    /**
     * 在微信环境下播放音频
     *
     * @param {any} element
     */
  weChat.prototype.playAudio = function (element) {
    wx.ready(() => {
      element.play();
    });
  };

    /**
     * 调用微信分享给朋友功能
     *
     * @param {Runtime.MessageShareData} params
     * @param { type }     description
     *        friends:     分享到微信朋友;
     *        friendsZone: 分享到微信朋友圈;
     *        QQ:          分享到QQ;
     *        QZone:       分享到QQ空间;
     *        weibo:       分享到腾讯微博;
     * @returns {Promise}
     */
  weChat.prototype.shareToFriends = function (params, type) {
    return new Promise((resolve, reject) => {
      if (params && (!params.title || !params.link || !params.imgUrl)) {
        return reject('分享的标题、链接、图标是必传参数');
      }
      wx.ready(() => {
        switch (type) {
          case 'friends':
            wx.onMenuShareAppMessage(__assign({}, params, { success: function () {
              resolve();
            },
              fail: function (res) {
                reject(res.errMsg);
              } }));
            break;
          case 'friendsZone':
            wx.onMenuShareTimeline(__assign({}, params, { success: function () {
              resolve();
            },
              fail: function (res) {
                reject(res.errMsg);
              } }));
            break;
          case 'weibo':
            wx.onMenuShareWeibo(__assign({}, params, { success: function () {
              resolve();
            },
              fail: function (res) {
                reject(res.errMsg);
              } }));
            break;
          case 'QQ':
            wx.onMenuShareQQ(__assign({}, params, { success: function () {
              resolve();
            },
              fail: function (res) {
                reject(res.errMsg);
              } }));
            break;
          case 'QZone':
            wx.onMenuShareQZone(__assign({}, params, { success: function () {
              resolve();
            },
              fail: function (res) {
                reject(res.errMsg);
              } }));
            break;
          default:
            wx.onMenuShareAppMessage(__assign({}, params, { success: function () {
              resolve();
            },
              fail: function (res) {
                reject(res.errMsg);
              } }));
            break;
        }
      });
    });
  };

    /**
     * 调用微信sdk的扫码功能
     *
     * @param {Runtime.ScanQRCodeData} params
     * @returns {Promise}
     */
  weChat.prototype.scanQRCode = function (params) {
    return new Promise((resolve, reject) => {
      if (!params) {
        return reject('扫码参数必传');
      }
      if (params.needResult === undefined) {
                // 如果没有指定needResult，默认是直接返回结果
        params.needResult = 1;
      }
      if (params.isNeedMock) {
        return resolve(params.mockData);
      }
      wx.ready(() => {
        wx.scanQRCode(__assign({}, params, { success: function (res) {
          const resVal = res.resultStr ? res.resultStr.replace(/\s+/g, '') : '';
          if (/^CODE_/i.test(resVal)) {
                            // 表明是通过条形码扫码得来:CODE_128,********
                            // 这个只针对扫快递条形码,如果是别的种类条形码还会有其他前缀比如ISBN等等......
            return resolve(resVal.split(',')[1]);
          }
          return resolve(resVal);
        },
          fail: function (res) {
            reject(res.errMsg);
          } }));
      });
    });
  };

    /**
     * 扫码派件，在微信不弹保险弹窗，直接调用微信sdk的扫码功能
     *
     * @param {Runtime.ScanQRCodeData} params
     * @returns {Promise}
     */
  weChat.prototype.openDialogThenScanQRCode = function (params) {
    return this.scanQRCode(params);
  };
    /**
     * 调用微信sdk获取地理位置功能
     *
     * @param {Runtime.GetLocationParam} params
     * @returns {Promise}
     */
  weChat.prototype.getLocation = function (params) {
    return new Promise((resolve, reject) => {
      if (params.type !== 'wgs84' && params.type !== 'gcj02') {
        return reject('参数不正确');
      }
      wx.ready(() => {
        wx.getLocation(__assign({}, params, { success: function (res) {
                        /** 纬度, 原始纬度值 * 1000000 */
          res.longitude = (res.longitude * 1000000).toFixed(0);
          res.latitude = (res.latitude * 1000000).toFixed(0);
          resolve(res);
        },
          fail: function (res) {
            reject(res.errMsg);
          },
          complete: function (res) {
            reject();
          } }));
      });
    });
  };

    /**
     * 调用微信sdk打开地理位置功能
     *
     * @param {Runtime.LocationData} location
     * @returns {Promise}
     */
  weChat.prototype.openLocation = function (params) {
    return new Promise((resolve, reject) => {
      if (params && (!params.latitude || !params.longitude)) {
        return reject('经纬度是必传参数');
      }
      wx.ready(() => {
        wx.openLocation(__assign({}, params, { success: function (res) {
          resolve(res);
        },
          fail: function (res) {
            reject(res.errMsg);
          } }));
      });
    });
  };

    /**
     * 调用微信sdk获取图片功能
     *
     * @param {Runtime.ChooseImageData} params
     * @returns {Promise}
     */
  weChat.prototype.chooseImage = function (params) {
    return new Promise((resolve, reject) => {
      if (params && (!params.count || !params.sizeType || !params.sourceType)) {
        return reject('图片选择参数必传');
      }
      wx.ready(() => {
        wx.chooseImage(__assign({}, params, { success: function (res) {
          resolve(res.localIds);
        },
          fail: function (res) {
            reject(res.errMsg);
          } }));
      });
    });
  };

    /**
     * 调用微信sdk上传图片功能
     *
     * @param {Runtime.UploadResource} params
     * @returns {Promise}
     */
  weChat.prototype.uploadImage = function (params) {
    return new Promise((resolve, reject) => {
      if (!params.localId) {
        return reject('请指定上传图片的ID号');
      }
      wx.ready(() => {
        wx.chooseImage(__assign({}, params, { sShowProgressTips: 1,
          success: function (res) {
            resolve(res.serverId);
          },
          fail: function (res) {
            reject(res.errMsg);
          } }));
      });
    });
  };
    /**
     * 调用微信sdk支付功能
     *
     * @param {Runtime.PayData} params
     * @returns {Promise}
     */
  weChat.prototype.chooseWXPay = function (params) {
    return new Promise((resolve, reject) => {
      if (!params.nonceStr || !params.package || !params.paySign) {
      }
      wx.ready(() => {
        wx.chooseWXPay(__assign({}, params, { timestamp: new Date().getTime(),
          success: function (res) {
                        // 支付成功后的回调函数
            resolve(res);
          },
          fail: function (res) {
            reject(res.errMsg);
          } }));
      });
    });
  };
    /**
     * 点我达APP打开一个对话框
     *
     * @param {Runtime.DwdDialogData} params
     */
  weChat.prototype.showDialog = function (params) {
  };
    /**
     * 点我达APP Native页面跳转
     *
     * @param {Runtime.DwdForwardToNativeData} params
     */
  weChat.prototype.forwardToNative = function (params) {
  };
  weChat.prototype.takeAndUploadPicture = function (params) {
  };
  weChat.prototype.httpRequest = function (params) {
  };
  weChat.prototype.setTitle = function (params) {
  };
  weChat.prototype.uploadBase64 = function (params) {
  };
    /**
     * wx环境下获取Native信息
     *
     * @param {Runtime.GetNativeDataParam} params
     * @returns {Promise}
     */
  weChat.prototype.getNativeData = function (params) {
    return new Promise((resolve, reject) => resolve(params.mockData));
  };

    /**
     * 点我达APP下webview监听消息
     *
     * @param {Runtime.onMessageParam} params
     * @returns {Promise}
     */
  weChat.prototype.onMessage = function (params) {
    return new Promise((resolve, reject) => resolve(params.mockData));
  };

    /**
     * 点我达APP下webview发送消息给别的webview
     *
     * @param {Runtime.postMessageParam} params
     * @returns {Promise}
     */
  weChat.prototype.postMessage = function (params) {
    return new Promise((resolve, reject) => resolve('发送事件成功'));
  };

    /**
     * 点我达APP下H5通知native某些事件
     *
     * @param {Runtime.notifyNativeParam} params
     * @returns {Promise}
     */
  weChat.prototype.notifyNative = function (params) {
    return new Promise((resolve, reject) => resolve('通知native成功'));
  };

    /** native 方法，拍照上传 */
  weChat.prototype.takePhotoAndUploadWithTips = function () { return Promise.resolve(); };
    /**
     * 是否支持微信支付
     */
  weChat.prototype.getSupportWXPay = function () { return Promise.resolve(); };

    /**
     * 微信支付
     */
  weChat.prototype.startWechatPay = function (params) {
    return Promise.resolve();
  };
    /**
     * 支付宝支付
     */
  weChat.prototype.startAliPay = function (params) {
    return Promise.resolve();
  };
    /**
     * 支付宝新SDK支付
     */
  weChat.prototype.startAliPayUrl = function (params) {
    return Promise.resolve();
  };
    /**
     * @description native 链接跳转方法
     * @param params url:native链接
     */
  weChat.prototype.dwdRoute = function (params) {
  };
  return weChat;
}());
exports.weChat = weChat;
